export default {
  controllerAs: 'ctrl',
  template: `
    <span>
      <input type="checkbox" disabled switcher ng-init="bogus = ctrl.value" ng-model="bogus" />
    </span>
  `,
  bindings: {
    value: '<',
  },
};
